"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.variableFormSchema = void 0;
const zod_1 = __importDefault(require("zod"));
const edd_config_page_validation_1 = require("@/edd/edd-config-page/edd-config-page.validation");
/* eslint-disable camelcase */
exports.variableFormSchema = zod_1.default
    .object({
    name: zod_1.default.string().trim().min(1, { message: 'Please enter a variable name' }),
    minDays: zod_1.default.preprocess((val) => {
        const num = Number(val);
        return isNaN(num) ? val : num;
    }, zod_1.default.number({ invalid_type_error: 'Minimum days must be a number' }).int('Minimum days must be a whole number').min(0, "Minimum days can't be negative")),
    maxDays: zod_1.default.preprocess((val) => {
        if (val === undefined || val === '') {
            return undefined;
        }
        const num = Number(val);
        return isNaN(num) ? val : num;
    }, zod_1.default.number({ invalid_type_error: 'Maximum days must be a number' }).int('Maximum days must be a whole number').min(0, "Maximum days can't be negative").optional()),
    fixedDate: zod_1.default.boolean()
})
    .superRefine((data, ctx) => (0, edd_config_page_validation_1.validateFixedDateMax)(data, ctx))
    .superRefine((data, ctx) => (0, edd_config_page_validation_1.validateMinLessThanMax)(data, ctx));
